import { LandingSubscriptionComponent } from './modules/main-landing-page/landing-subscription/landing-subscription.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AfterLoginGuard} from './guards/after-login.guard';
import {NotAllowedComponent} from "./shared/components/not-allowed/not-allowed.component";
import {StaffGuard} from "./guards/staff.guard";
import {LoginComponent} from "./guest/login/login.component";
import {PageComponent} from "./page/page.component";
import { LandingPageComponent } from './shared/components/landing-page/landing-page.component';
import {ForgotPasswordComponent} from "./guest/forgot-password/forgot-password.component";
import {CheckYourEmailComponent} from "./guest/check-your-email/check-your-email.component";
import {ResetPasswordComponent} from "./guest/reset-password/reset-password.component";
import {SetPasswordComponent} from "./guest/set-password/set-password.component";
import { UserProfileComponent } from './shared/components/user-profile/user-profile.component';
import { MainLandingPageComponent } from './modules/main-landing-page/main-landing-page.component';
import { ProductComponent } from './modules/setting-management/product/product.component';
import { ArticleByGazetiComponent } from './modules/main-landing-page/article-by-gazeti/article-by-gazeti.component';
import { GazetPreviewComponent } from './modules/main-landing-page/gazet-preview/gazet-preview.component';
import { PaymentSuccessComponent } from './shared/components/payment/payment-success/payment-success.component';
import { PaymentFailedComponent } from './shared/components/payment/payment-failed/payment-failed.component';
import { CorporateLandingComponent } from './modules/main-landing-page/corporate-landing/corporate-landing.component';
import { CorporateSubscriptionComponent } from './modules/main-landing-page/corporate-subscription/corporate-subscription.component';
import { CorporateBillingComponent } from './modules/main-landing-page/corporate-billing/corporate-billing.component';
import { CorporateReadersComponent } from './modules/main-landing-page/corporate-readers/corporate-readers.component';
import { CorporateBillingViewComponent } from './modules/main-landing-page/corporate-billing/corporate-billing-view/corporate-billing-view.component';
import { CorporateReadersViewComponent } from './modules/main-landing-page/corporate-readers/corporate-readers-view/corporate-readers-view.component';
import { CorporateSubscriptionViewComponent } from './modules/main-landing-page/corporate-subscription/corporate-subscription-view/corporate-subscription-view.component';
import { CorporateTodayTrendsComponent } from './modules/main-landing-page/corporate-today-trends/corporate-today-trends.component';
import { CorporatePaymentComponent } from './modules/main-landing-page/corporate-payment/corporate-payment.component';
import { CorporatePaymentViewComponent } from './modules/main-landing-page/corporate-payment/corporate-payment-view/corporate-payment-view.component';
import { StoriesSectionComponent } from './modules/main-landing-page/stories-section/stories-section.component';

const routes: Routes = [
 {
    path: '',
    redirectTo: 'landing',  
    pathMatch: 'full'
  },
  {
    path: 'not-allowed',
    component: NotAllowedComponent,
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'landing',
    component: MainLandingPageComponent,
    // remove the guard if you want everyone (even guests) to see it
    // canActivate: [AfterLoginGuard],
  },
  {
          path: "gazeti-magazine/:gazetiId",
          component: ArticleByGazetiComponent,
         
        },
  {
    path: 'manage',
    component: PageComponent,
    children: [
      {
        path: 'user-management',
        loadChildren: () =>
          import(
            './modules/user-management/user-management.module'
            ).then((m) => m.UserManagementModule),
        canActivate: [AfterLoginGuard],
      },
   
      {
        path: 'setting-management',
        loadChildren: () =>
          import(
            './modules/setting-management/setting-management.module'
            ).then((m) => m.SettingManagementModule),
        canActivate: [AfterLoginGuard],
      },

        {
        path: 'workflow-management',
        loadChildren: () =>
          import(
            './modules/work-flow/work-flow.module'
            ).then((m) => m.WorkFlowModule),
        canActivate: [AfterLoginGuard],
      },
    

        {
        path: 'articles-management',
        loadChildren: () =>
          import(
            './modules/articles-management/articles-management.module'
            ).then((m) => m.ArticlesManagementModule),
        canActivate: [AfterLoginGuard],
      },

        {
        path: 'media-management',
        loadChildren: () =>
          import(
            './modules/media-management/media-management.module'
            ).then((m) => m.MediaManagementModule),
        canActivate: [AfterLoginGuard],
      },
      {
        path: 'subscription-management',
        loadChildren: () =>
          import(
            './modules/subscription-management/subscription-management.module'
            ).then((m) => m.SubscriptionManagementModule),
        canActivate: [AfterLoginGuard],
      },
       {
        path: 'billing-management',
        loadChildren: () =>
          import(
            './modules/billing-management/billing-management.module'
            ).then((m) => m.BillingManagementModule),
        canActivate: [AfterLoginGuard],
      },

       {
        path: 'readers-management',
        loadChildren: () =>
          import(
            './modules/readers-management/readers-management.module'
            ).then((m) => m.ReadersManagementModule),
        canActivate: [AfterLoginGuard],
      },



   
    
    ]
  },

  //  {
  //   path: 'settings',
  //   loadChildren: () =>
  //     import('./modules/settings/settings.module').then(
  //       (m) => m.SettingsModule
  //     ),
  //   canActivate: [AfterLoginGuard],
  
  // },
  {
    path: 'innerlanding',
    component: LandingPageComponent,
    canActivate: [AfterLoginGuard],
  },
    {
    path: 'subscription',
    component: LandingSubscriptionComponent,
    canActivate: [AfterLoginGuard],
  },
     {
    path: 'corporate-landing',
    component: CorporateLandingComponent,
    canActivate: [AfterLoginGuard],
  },
  {
  path: 'corporate',
  component: CorporateLandingComponent,
  canActivate: [AfterLoginGuard],
  children: [

    { path: '', redirectTo: 'today-trends', pathMatch: 'full' },

    { path: 'today-trends', component: CorporateTodayTrendsComponent },

    { path: 'billing', component: CorporateBillingComponent },
    { path: 'billing/:uuid', component: CorporateBillingViewComponent },

    { path: 'readers', component: CorporateReadersComponent },
    { path: 'readers/:uuid', component: CorporateReadersViewComponent },

    { path: 'subscription', component: CorporateSubscriptionComponent },
    { path: 'subscription/:uuid', component: CorporateSubscriptionViewComponent },

    { path: 'payment', component: CorporatePaymentComponent },
    { path: 'payment/:uuid', component: CorporatePaymentViewComponent },

  ]
},

     {
   path: 'gazeti-preview/:gazetiId',
    component: GazetPreviewComponent,
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'check-your-email',
    component: CheckYourEmailComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
   

  
  {
    path: 'set-password',
    component: SetPasswordComponent
  },
  {
    path: 'user-profile',
    component: UserProfileComponent
  },
  {
    path: 'payment/success',
    component: PaymentSuccessComponent
  },
  {
    path: 'payment/failed',
    component: PaymentFailedComponent
  },

   {
    path: 'landing/stories',
    component: StoriesSectionComponent
  },

  
  {
    path: 'story/:id',
    loadChildren: () =>
      import(
        './modules/story-details/story-details.module'
      ).then((m) => m.StoryDetailsModule),
  },
//  { path: 'subscription-management', loadChildren: () => import('./subscription-management/subscription-management.module').then(m => m.SubscriptionManagementModule) },
  {path: '**', component: NotAllowedComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {anchorScrolling: 'enabled'}
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}

